import React, { useEffect, useState } from "react";
import CartTable2 from "../../../../components/AdminTable/CardTable2";
import axios from "axios";
import { apiKey } from "../../../../config/config";
import MessageCard from "../../../../components/AdminCards/MessageCard";
import ShiftModal from "../../../../components/AdminCards/ShiftModal";
import { languageHelper } from "../../../../config/helperFunctions";



function RegisterReport({ logo, general, currency }) {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const columns = [
    {
      header: languageHelper("SN") || "SN",
      cell: (row) => row.row.index + 1,
    },

    {
      header: languageHelper("Opening Date & Time") || "Opening Date & Time",
      accessorKey: "opening_balance_date_time",
    },
    {
      header: languageHelper("Opening Balance") || "Opening Balance",
      accessorKey: "opening_balance",
    },
    {
      header: languageHelper("All Sales (Paid Amount)") || "All Sales (Paid Amount)",
      accessorKey: "sub_total_amount",
    },
    {
      header: languageHelper("Total Vat") || "Total Vat",
      accessorKey: "total_vat_amount",
    },
    {
      header: languageHelper("Total Return") || "Total Return",
      accessorKey: "total_return",
    },
    // {
    //   header: languageHelper("Total Expense") || "Total Expense",
    //   accessorKey: "total_expense",
    // },
    // {
    //   header: languageHelper("Customer Due Receive") || "Customer Due Receive",
    //   accessorKey: "customer_due_receiv",
    // },
    {
      header: languageHelper("Closing Date & Time") || "Closing Date & Time",
      accessorKey: "closing_balance_date_time",
    },
    {
      header: languageHelper("Closing Balance") || "Closing Balance",
      accessorKey: "closing_balance",
    },
    {
      header: languageHelper("Actions") || "Actions",
      cell: (row) => (
        <button
          onClick={() => {
            setSelectedReport({ shift: row.row.original });
          }}
          className="text-xs bg-gray-100 text-black px-2 py-1 rounded"
        >
          {languageHelper("Preview")}
        </button>
      ),
    },
  ];
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [error, setError] = useState(false);
  const [users, setUsers] = useState([]);
  const [data, setData] = useState([]);
  const [selectedUser, setSelectedUser] = useState();
  const [selectedReport, setSelectedReport] = useState();

  // const [showShiftModal, setShowShiftModal] = useState(false);
  const toggleModal = (show) => {
    setSelectedReport(show);
  };

  const handleUserSelect = (e) => {
    setSelectedUser(e.value);
  };

  // const buttonDataa = [
  //   {
  //     buttonText: "Submit",
  //   },
  // ];

  const [selectedOutlet, setSelectedOutlet] = useState();
  const handleOutletSelect = (e) => {
    setSelectedOutlet(e.value);
  };

  const selectButton = [
    {
      placeholder: languageHelper("User") || "User",
      options: users,
      onChange: handleUserSelect,
    },
  ];

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/user`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id,
        },
      })
      .then((res) => {
        const mappedCustomers = res.data.map((user) => ({
          value: user.id,
          label: user.name,
        }));
        setUsers(mappedCustomers);
        setError(false);
      })
      .catch((err) => {
        setError(err.response.data.message || "Error occured");
      })
      .finally(() => {});
  }, [user?.token, user?.user.outlet_id]);

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/shift-report`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: selectedOutlet || user?.user.outlet_id,
          start_date: startDate,
          end_date: endDate,
          user_id: selectedUser,
        },
      })
      .then((res) => {
        setData(res.data);
        setError(false);
      })
      .catch((err) => {
        setError(err.response.data.message || "Error occured");
      })
      .finally(() => {});
  }, [
    endDate,
    selectedOutlet,
    selectedUser,
    startDate,
    user?.token,
    user?.user.outlet_id,
  ]);

  if (error) {
    return <MessageCard error={error} />;
  }

  return (
    <main>
      <CartTable2
        data={data}
        columns={columns}
        heading={languageHelper("Register Report") || "Register Report"}
        // buttonDataa={buttonDataa}
        selectButton={selectButton}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        downloads={true}
        handleOutletSelect={handleOutletSelect}
      />
      {selectedReport && (
        <ShiftModal
          logo={logo}
          general={general}
          currency={currency}
          data={selectedReport}
          toggle={toggleModal}
          isPreview={true}
        />
      )}
    </main>
  );
}

export default RegisterReport;
